
import { LOGOUT_USER } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  logoutUser,
  logoutUserPending,
  logoutUserFulfilled,
  logoutUserRejected,
} = createAsyncActions(LOGOUT_USER, 'logoutUser');


// WEBPACK FOOTER //
// ./src/actions/logoutUser.js